import gql from 'graphql-tag';

import { useMutation } from '@apollo/client';
import { AssignVisit, AssignVisitVariables } from '../../athena/types/AssignVisit';

export const ASSIGN_VISIT = gql`
  mutation AssignVisit($id: String!, $userToken: String!) {
    trippy {
      updateVisit(input: { id: $id, assignedUserToken: $userToken }) {
        id
      }
    }
  }
`;

export const useAssignVisit = () => {
  return useMutation<AssignVisit, AssignVisitVariables>(ASSIGN_VISIT);
};
